import { CLOSE_EDIT_ABOUTME, CLOSE_EDIT_BIO, CLOSE_EDIT_INTERESTS, CLOSE_EDIT_LOOKINGFOR, OPEN_EDIT_ABOUTME, OPEN_EDIT_BIO, OPEN_EDIT_INTERESTS, OPEN_EDIT_LOOKINGFOR } from "../types"




export const ModalsControlReducer = (state = {openInterests: false, openAboutme: false, openLookingFor: false, openBio: false}, action) => {
switch (action.type) {
    case OPEN_EDIT_INTERESTS:
        return {...state, openInterests: true}
    case CLOSE_EDIT_INTERESTS:
        return {...state, openInterests: false}
    case OPEN_EDIT_ABOUTME:
        return {...state, openAboutme: true}
    case CLOSE_EDIT_ABOUTME:
        return {...state, openAboutme: false}
    case OPEN_EDIT_LOOKINGFOR:
        return {...state, openLookingFor: true}
    case CLOSE_EDIT_LOOKINGFOR:
        return {...state, openLookingFor: false}
    case OPEN_EDIT_BIO:
            return {...state, openBio: true}
    case CLOSE_EDIT_BIO:
            return {...state, openBio: false}
    default:
        return state
}
}
  